import React, { useRef, useState } from 'react'
import Background from '../../assets/backgrounds/epp.svg'
import BackgroundMobile from '../../assets/backgrounds/epp-mobile.svg'
import { Color } from '../../utils/constants'
import PageHeader from '../../partials/PageHeader'
import Performance from './components/Performance'
import Testimonials from '../../partials/Testimonials/TestimonialsAlt'
import Partners from '../../partials/Partners'
import Improvement from './components/Improvement/Improvement'
import Unique from './components/Unique'
import Segments from './components/SegmentsAlt'
import Approaches from './components/Approaches'
import UseCases from './components/UseCases'
import Reimagine from './components/Reimagine'
import LinkCards from '../../partials/LinkCards/LinkCards'
import PaddingContext, { PaddingProps } from '../../utils/PaddingContext'

const EPP = () => {
    const scrollRef = useRef<HTMLDivElement>(null)
    const [padding, setPadding] = useState<PaddingProps>()

    return (
        <PaddingContext.Provider value={{ padding }}>
            <div className='relative'>
                <PageHeader
                    title='page.epp.title'
                    description='page.epp.description'
                    bgColor={Color.PURPLE}
                    component={Background}
                    mobileComponent={BackgroundMobile}
                    link={'/'}
                />
                <div className='bg-white'>
                    <Performance scrollRef={scrollRef} />
                    <Partners>
                        <div className='w-full h-px bg-black/10'></div>
                    </Partners>
                    <Unique />
                    <Improvement />
                    <div ref={scrollRef}>
                        <Segments />
                    </div>
                    <Approaches />
                    <Testimonials setPadding={setPadding} />
                    <UseCases setPadding={setPadding} />
                    <Reimagine />
                    <LinkCards
                        title1='section.linkCard.getInTouch'
                        link1='/contact'
                        title2='page.careers.become'
                        link2='https://careers.biomatter.ai/'
                        external2={true}
                    />
                </div>
            </div>
        </PaddingContext.Provider>
    )
}

export default EPP
